import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=40a79ac2&"
import script from "./OptionEditor.vue?vue&type=script&lang=ts&"
export * from "./OptionEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports